/* eslint-disable no-param-reassign */
 
const $ = require('lib/jquery')
const _ = require('lib/underscore')
const keycode = require('lib/keycode')
const log = require('log').create('escape') // eslint-disable-line


const Escape = {
    listening: false,
    stack: [],
    handlers: {},
    focushandlers: {},

    listen(id, handler, focushandler) {
        if (! id) throw new Error('Escape.listen requires an id as first argument')
        if (! _.isFunction(handler)) throw new Error('Escape.listen requires a handler function as second argument')
        // log('Escape: adding '+id);
        this.unlisten(id)
        this.stack.unshift(id)
        this.handlers[id] = handler
        if (_.isFunction(focushandler)) this.focushandlers[id] = focushandler
        // log(this.stack)
        this._on()

    },
    unlisten(id) {
        const index = _.indexOf(this.stack, id)
        if (index === -1) return

        // remove a dialog from the stack
        this.stack.splice(index, 1)
        delete this.handlers[id]
        delete this.focushandlers[id]

        if (index === 0 && this.stack.length) {
            // some other listener is now topmost, see if they'd like to be notified
            id = this.stack[0]
            if (id && this.focushandlers[id]) {
                this.focushandlers[id]()
            }
        }

        // log(this.stack)
        this._off()
    },
    trigger() {
        // trigger most recently added listener
        const id = this.stack[0]
        // log('id', id)
        // log('this.stack', this.stack)
        if (id && this.handlers[id]) {
            this.handlers[id]()
        }
    },

    validateKey(e) {
        // TODO add support for other keystrokes?
        // would be nice to close a modal with cmd-W, but can't seem to prevent Cmd-W from closing the window
        if (e.which === keycode.ESCAPE) return true
        return false
    },

    _on() {
        if (this.listening) return
        $.window.on('keyup.escape', (e) => {
            if (Escape.validateKey(e)) {
                Escape.trigger()
            }
        })
        this.listening = true
    },
    _off() {
        if (! this.stack.length) {
            $.window.off('keyup.escape')
            this.listening = false
        }
    },

}

module.exports = Escape
